import React from 'react';
import { Card, CardBody, CardHeader, CardFooter } from 'reactstrap';
import './MainCard.scss';
import './../../../common/scss/input.scss';

type Props = {
  header?: any;
  body?: any;
  footer?: any;
  [key: string]: any;
};

const MainCard = ({ header, body, footer, ...props }: Props) => (
  <Card {...props} className="main-card">
    {header && <CardHeader className="main-card__header">{header}</CardHeader>}
    {body && <CardBody className="main-card__body">{body}</CardBody>}
    {footer && <CardFooter className="main-card__footer">{footer}</CardFooter>}
  </Card>
);

export default MainCard;
